import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { AMCActions } from '../../Redux';

export const ForexExchangeSpy = ({ values, form }: any) => {
  const dispatch = useDispatch();
  const { forexPayments } = useSelector((state: any) => state.PMCReducers);
  const { fxAccountCurrency } = useSelector((state: any) => state.AMCReducers);

  const getAccountCurrency = (accountId: string) => {
    return forexPayments?.InitialAccounts.find((el: any) => el.AccountID === accountId)?.CurrencyName;
  };

  useEffect(() => {
    if (values?.Payment?.FromAccount) {
      const accountCurrency = getAccountCurrency(values?.Payment?.FromAccount);

      if (accountCurrency && fxAccountCurrency !== accountCurrency) {
        dispatch<any>(AMCActions.getForexCurrency(accountCurrency));
      }
    }
  }, [values?.Payment?.FromAccount]);

  useEffect(() => {
    if (!values?.Payment?.Currency || !values?.Payment?.BeneficiaryAccountNumber || !values?.Payment?.FromAccount || values?.Payment.canBuy) {
      if (values?.Payment.canBuy && (!values?.Payment?.Currency || !values?.Payment?.BeneficiaryAccountNumber || !values?.Payment?.FromAccount)) {
        form.change('Payment.canBuy', false);
      }

      return;
    }

    form.change('Payment.canBuy', true);
  }, [values?.Payment?.Currency, values?.Payment?.BeneficiaryAccountNumber, values?.Payment?.FromAccount]);

  return null;
};
